export enum ACLS {
  FM_HM_ACL = "FmHmAcl",
  ORACLE_ACL = "FmHmOracle",
  ADMIN_ACL = "FmHmAdminAcl",
  AGENTIC_INTERNAL_ADMIN = "AgenticInternalAdmin",
  PLATFORM_ACCOUNT_ADMIN = "PlatformAccountAdmin",
  PLATFORM_UPDATE_ACCOUNT_SCOPE = "PlatformUpdateAccountScope",
  FM_AGENT_ACL = "FmAgent",
  FM_CRED_ADMIN_ACL = "FmCredAdminAcl",
}
